// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".atom-text *{color:#000;font-family:\"effra\",Arial,sans-serif;font-size:1.375rem;font-weight:400;line-height:1.625rem}@media only screen and (max-width:767px){.atom-text *{color:#000;font-family:\"effra\",Arial,sans-serif;font-size:.875rem;font-weight:400;line-height:1.188rem}}.atom-text p{margin-bottom:.313rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
